import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import ImageNotSupportedOutlinedIcon from '@mui/icons-material/ImageNotSupportedOutlined';
import { alpha, useTheme } from '@mui/material/styles';

export function CardImage({
  src,
  alt,
  aspectRatio = '1 / 1',
  rounded = 2.5,
  iconSize = 32,
  fit = 'contain',
  inactive = false,
  padded = true,
  bordered = true,
}) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(src) && !failed;

  useEffect(() => {
    setFailed(false);
  }, [src]);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        aspectRatio,
        borderRadius: rounded,
        background: isDark
          ? `linear-gradient(180deg, ${alpha('#3ab5b0', 0.12)} 0%, ${alpha('#1e1e1e', 0.9)} 100%)`
          : 'linear-gradient(180deg, rgba(58,181,176,0.08) 0%, #ffffff 100%)',
        border: bordered ? 1 : 0,
        borderColor: 'divider',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: padded ? { xs: 1.25, sm: 1.5 } : 0,
        boxShadow: bordered ? `inset 0 0 0 1px ${alpha(theme.palette.primary.main, 0.06)}` : 'none',
      }}
    >
      {showImage ? (
        <Box
          component="img"
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: fit,
            objectPosition: 'center',
            display: 'block',
            transition: 'transform 0.25s ease',
            filter: inactive ? 'grayscale(0.65) opacity(0.55)' : 'none',
            '.MuiCard-root:hover &': inactive ? undefined : { transform: 'scale(1.04)' },
          }}
        />
      ) : (
        <ImageNotSupportedOutlinedIcon
          sx={{ color: 'primary.main', opacity: 0.4, fontSize: iconSize }}
          aria-hidden
        />
      )}
    </Box>
  );
}
